import { render, staticRenderFns } from "./volunteers.vue?vue&type=template&id=e1008e5e&scoped=true&"
import script from "./volunteers.vue?vue&type=script&lang=js&"
export * from "./volunteers.vue?vue&type=script&lang=js&"
import style0 from "./volunteers.vue?vue&type=style&index=0&id=e1008e5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1008e5e",
  null
  
)

export default component.exports